import { render, staticRenderFns } from "./PostQuestions.vue?vue&type=template&id=7235e24c&scoped=true&"
import script from "./PostQuestions.vue?vue&type=script&lang=js&"
export * from "./PostQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7235e24c",
  null
  
)

export default component.exports